import { AwmFundParams, AwmFundResponse } from '@repo/accounts-types'
import { ApiResponse, Service } from '@repo/core'
import { AxiosRequestConfig } from 'axios'

export const getAwmFunds: Service<
  AwmFundParams,
  ApiResponse<AwmFundResponse>,
  Pick<AxiosRequestConfig, 'signal'>
> = async ({ api, params, accept, config }) => {
  const { securitiesAccountId, isinId, ...queryParams } = params

  return api.get<ApiResponse<AwmFundResponse>>(
    `/accounts/securities/${securitiesAccountId}/products/${isinId}/awm-funds`,
    {
      params: queryParams,
      ...config,
      ...(accept && { headers: { Accept: accept }, responseType: 'blob' as const }),
    },
  )
}
